import { lazy } from "react";

const ClientStatus = lazy(() => import("./ClientStatus"));
const AddClient = lazy(() => import("./AddClient"));
const EditClient=lazy(()=>import("./EditClient"));
const clientsRoutes = [
  { path: "/clients", element: <ClientStatus /> },
  { path: "/clients/add", element: <AddClient /> },
  { path: "/clients/edit/:id", element: <EditClient /> }

];

export default clientsRoutes;
